/**
 * Default Theme Configuration
 * Uses Shapermint theme from afrodita-components
 */

import { shapermintTheme } from '@template-project/afrodita-components';

/**
 * Export Shapermint theme as default
 * Can be overridden per environment or store
 */
export const defaultTheme = shapermintTheme;
